import { type PseudoStateDataMap } from '../../types';
import { hasStateData, pseudoStatesPriority } from '../pseudo-state-shared';

/**
 * Checks whether any pseudo state data is present.
 *
 * @since ??
 *
 * @param {PseudoStateDataMap<any>} stateDataMap State data map.
 *
 * @returns {boolean} Whether any pseudo state has data.
 */
export const hasPseudoStateData = <TStateData>(stateDataMap: PseudoStateDataMap<TStateData>): boolean =>
  pseudoStatesPriority.some(state => hasStateData(stateDataMap, state));
